/* =====================================================================
   Don Barato · quick-add.js
   1) Miniaturas de variante en las tarjetas ([data-sw]): al pasar (escritorio) o tocar (móvil)
      cambian la foto, el precio y el enlace de la tarjeta.
   2) Hoja rápida ([data-quick-open]): pide /products/<handle>?section_id=quick-add, la muestra en un
      cajón (abajo en móvil, centrado en escritorio), deja elegir variante con foto y agrega al carro
      con window.DonBaratoCart (assets/cart.js). Si algo falla, lleva a la ficha del producto.
   ===================================================================== */
(function () {
  const DB = (window.DonBarato = window.DonBarato || {});
  const fmt = (c) => (DB.formatMoney ? DB.formatMoney(c) : '$' + Math.round(c / 100));
  const canHover = window.matchMedia('(hover: hover)');

  /* ---------- 1) Miniaturas en la tarjeta ---------- */
  function selectSwatch(sw) {
    const card = sw.closest('[data-card]');
    if (!card || sw.classList.contains('is-on')) return;
    card.querySelectorAll('[data-sw]').forEach((b) => b.classList.toggle('is-on', b === sw));
    const img = card.querySelector('.card__img img');
    if (img && sw.dataset.img) {
      if (sw.dataset.srcset) img.srcset = sw.dataset.srcset;
      img.src = sw.dataset.img;
    }
    card.querySelectorAll('[data-card-link]').forEach((a) => (a.href = sw.dataset.url));
    const price = card.querySelector('[data-card-price]');
    if (price) {
      const old = sw.dataset.old;
      price.innerHTML =
        `<div class="price price--md${old ? ' is-sale' : ''}"><span class="price__current">${sw.dataset.price}</span>` +
        (old ? `<s class="price__old">${old}</s>` : '') + '</div>';
    }
    card.dataset.variant = sw.dataset.variant;
  }
  document.addEventListener('click', (e) => {
    const sw = e.target.closest('[data-sw]');
    if (!sw) return;
    e.preventDefault();
    selectSwatch(sw);
  });
  document.addEventListener('mouseover', (e) => {
    if (!canHover.matches) return;
    const sw = e.target.closest('[data-sw]');
    if (sw) selectSwatch(sw);
  });

  /* ---------- 2) Hoja rápida ---------- */
  let sheet = null;
  const cache = new Map();

  function load(url) {
    if (!cache.has(url)) {
      const sep = url.includes('?') ? '&' : '?';
      cache.set(
        url,
        fetch(url + sep + 'section_id=quick-add').then((r) => {
          if (!r.ok) throw new Error('quick-add');
          return r.text();
        })
      );
    }
    return cache.get(url);
  }

  function ensureSheet() {
    if (sheet) return sheet;
    sheet = document.createElement('div');
    sheet.className = 'drawer drawer--sheet';
    sheet.id = 'QuickAdd';
    sheet.hidden = true;
    sheet.setAttribute('aria-hidden', 'true');
    sheet.innerHTML =
      '<div class="drawer__overlay" data-drawer-close></div>' +
      '<div class="drawer__panel qa-panel" role="dialog" aria-modal="true" aria-label="Elegir opciones"><div class="qa-body" data-qa-body></div></div>';
    document.body.appendChild(sheet);
    sheet.addEventListener('change', onChange);
    sheet.addEventListener('click', onClick);
    sheet.addEventListener('submit', onSubmit);
    sheet.addEventListener('db:submit', onSubmit); // clic sin envío del formulario (global.js)
    return sheet;
  }

  // Precarga al acercar el mouse o el dedo al «+»
  ['pointerenter', 'touchstart'].forEach((type) =>
    document.addEventListener(
      type,
      (e) => {
        const b = e.target.closest && e.target.closest('[data-quick-open]');
        if (b) load(b.dataset.quickOpen).catch(() => {});
      },
      { capture: true, passive: true }
    )
  );

  document.addEventListener('click', async (e) => {
    const btn = e.target.closest('[data-quick-open]');
    if (!btn) return;
    e.preventDefault();
    const url = btn.dataset.quickOpen;
    btn.classList.add('is-loading');
    try {
      const html = await load(url);
      const qa = new DOMParser().parseFromString(html, 'text/html').querySelector('[data-qa]');
      if (!qa) throw new Error('quick-add');
      const body = ensureSheet().querySelector('[data-qa-body]');
      body.replaceChildren(qa);
      const card = btn.closest('[data-card]');
      if (card && card.dataset.variant) selectVariant(Number(card.dataset.variant));
      refresh();
      DB.openDrawer('QuickAdd', btn);
    } catch (err) {
      window.location.href = url;
    } finally {
      btn.classList.remove('is-loading');
    }
  });

  const current = () => sheet && sheet.querySelector('[data-qa]');
  const data = (qa) => JSON.parse(qa.querySelector('[data-qa-json]').textContent);
  const fieldsets = (qa) => [...qa.querySelectorAll('[data-qa-opt]')];

  // Opciones elegidas en el orden del producto (las opciones de un solo valor no tienen selector).
  function selected(qa, d) {
    const opts = d.variants[0].options.slice();
    const base = Number(qa.querySelector('[data-qa-id]').value);
    const cur = d.variants.find((v) => v.id === base) || d.variants[0];
    cur.options.forEach((o, i) => (opts[i] = o));
    fieldsets(qa).forEach((fs) => {
      const c = fs.querySelector('input:checked');
      if (c) opts[Number(fs.dataset.qaOpt)] = c.value;
    });
    return opts;
  }
  const find = (d, opts) => d.variants.find((v) => v.options.every((o, i) => o === opts[i]));

  function selectVariant(id) {
    const qa = current();
    const d = data(qa);
    const v = d.variants.find((x) => x.id === id);
    if (!v) return;
    qa.querySelector('[data-qa-id]').value = v.id;
    fieldsets(qa).forEach((fs) => {
      const val = v.options[Number(fs.dataset.qaOpt)];
      const inp = [...fs.querySelectorAll('input')].find((x) => x.value === val);
      if (inp) inp.checked = true;
    });
  }

  const qty = (qa) => Math.max(1, Math.min(99, parseInt((qa.querySelector('[data-qa-qty]') || {}).value, 10) || 1));

  function priceHTML(v) {
    const sale = v.compare > v.price;
    const pct = sale ? Math.round(((v.compare - v.price) * 100) / v.compare) : 0;
    return (
      `<div class="price price--md${sale ? ' is-sale' : ''}"><span class="price__current">${fmt(v.price)}</span>` +
      (sale ? `<s class="price__old">${fmt(v.compare)}</s><span class="badge badge--lime price__badge">-${pct}%</span>` : '') +
      '</div>'
    );
  }

  function refresh(changedIndex) {
    const qa = current();
    if (!qa) return;
    const d = data(qa);
    let opts = selected(qa, d);
    let v = find(d, opts);
    if (!v && changedIndex != null) {
      // La combinación no existe: la primera disponible con el valor recién elegido.
      v =
        d.variants.find((x) => x.available && x.options[changedIndex] === opts[changedIndex]) ||
        d.variants.find((x) => x.options[changedIndex] === opts[changedIndex]);
      if (v) {
        selectVariant(v.id);
        opts = v.options.slice();
      }
    }
    if (v) qa.querySelector('[data-qa-id]').value = v.id;

    fieldsets(qa).forEach((fs) => {
      const i = Number(fs.dataset.qaOpt);
      const label = fs.querySelector('[data-qa-sel]');
      if (label) label.textContent = opts[i] || '';
      const isPack = fs.classList.contains('qa__opt--packs');
      const inputs = [...fs.querySelectorAll('input')];
      const base = isPack ? find(d, Object.assign(opts.slice(), { [i]: inputs[0].value })) : null;
      inputs.forEach((inp) => {
        const vv = find(d, Object.assign(opts.slice(), { [i]: inp.value }));
        const lab = inp.closest('label');
        lab.classList.toggle('is-off', !vv || !vv.available);
        const pr = lab.querySelector('[data-qa-vprice]');
        if (pr) pr.textContent = vv ? fmt(vv.price) : 'No disponible';
        if (isPack) {
          lab.classList.toggle('is-free', !!(vv && vv.available && d.th > 0 && vv.price >= d.th));
          const n = parseInt(inp.value, 10) || 1;
          const save = lab.querySelector('[data-qa-save]');
          const pct = lab.querySelector('[data-qa-pct]');
          const full = base && vv ? base.price * n : 0;
          const ahorro = full && vv ? full - vv.price : 0;
          if (save) save.textContent = ahorro > 0 ? 'Ahorras ' + fmt(ahorro) : 'Precio normal';
          if (pct) {
            pct.hidden = !(ahorro > 0);
            if (ahorro > 0) pct.textContent = '-' + Math.round((ahorro * 100) / full) + '%';
          }
        }
      });
    });

    if (!v) return;
    // Cuántas quedan (packs: se cuentan en packs; resto: en unidades). En rojo cuando quedan 10 o menos.
    const left = qa.querySelector('[data-qa-left]');
    if (left) {
      const packFs = qa.querySelector('.qa__opt--packs');
      const checked = packFs && packFs.querySelector('input:checked');
      const n = (checked && parseInt(checked.value, 10)) || 1;
      if (v.tracked && v.available && v.inv > 0) {
        const low = v.inv <= 10;
        const unit = n > 1 ? (v.inv === 1 ? 'pack' : 'packs') : v.inv === 1 ? 'unidad' : 'unidades';
        left.hidden = false;
        left.classList.toggle('is-low', low);
        left.innerHTML = `<i aria-hidden="true"></i><span>${low ? '¡Últimas' : 'Quedan'} <b>${v.inv}</b> ${unit}${low ? '!' : ''}</span>`;
      } else {
        left.hidden = true;
      }
    }
    const wrap = qa.querySelector('[data-qa-imgwrap]');
    const img = wrap && wrap.querySelector('img');
    if (img && v.img) {
      img.removeAttribute('srcset');
      img.src = v.img;
    }
    const price = qa.querySelector('[data-qa-price]');
    if (price) price.innerHTML = priceHTML(v);
    const add = qa.querySelector('[data-qa-add]');
    add.disabled = !v.available;
    const text = qa.querySelector('[data-qa-btn-text]');
    if (text) text.textContent = v.available ? 'Agregar al carro · ' + fmt(v.price * qty(qa)) : 'Agotado';
  }

  function onChange(e) {
    const fs = e.target.closest('[data-qa-opt]');
    if (fs) return refresh(Number(fs.dataset.qaOpt));
    if (e.target.matches('[data-qa-qty]')) {
      e.target.value = qty(current());
      refresh();
    }
  }

  function onClick(e) {
    const step = e.target.closest('[data-qa-step]');
    if (!step) return;
    const q = current().querySelector('[data-qa-qty]');
    q.value = Math.max(1, Math.min(99, (parseInt(q.value, 10) || 1) + Number(step.dataset.qaStep)));
    refresh();
  }

  async function onSubmit(e) {
    const form = e.target.closest('[data-qa-form]');
    if (!form || !window.DonBaratoCart) return; // sin el carro lateral, el formulario va a /cart/add
    e.preventDefault();
    const btn = form.querySelector('[data-qa-add]');
    const id = Number(form.querySelector('[data-qa-id]').value);
    const quantity = qty(current());
    btn.classList.add('is-loading');
    try {
      DB.closeDrawer('QuickAdd'); // se cierra antes, para que el carro lateral se abra encima sin pelear por el foco
      await window.DonBaratoCart.add([{ id, quantity }], { trigger: btn });
    } catch (err) {
      if (DB.toast) DB.toast((err && err.message) || 'No se pudo agregar. Intenta de nuevo.');
    } finally {
      btn.classList.remove('is-loading');
    }
  }
})();
